import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><path d=\"M8 4c.912-1.219 2.36-2 4-2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1-10 0V7\"></path><path d=\"M12 8a1 1 0 1 0-1-1M11.291 11.295a1 1 0 0 0 1.418 1.41\"></path><circle cx=\"12\" cy=\"17\" r=\"1\"></circle><path d=\"m3 3 18 18\"></path>", 5)
  ]))]))
}
export default { render: render }